import { useEffect, useState } from 'react';
import axios from 'axios';
import { useSearchParams, Link } from 'react-router-dom';
import Loader from '../Layouts/Loader';
import MetaData from '../Layouts/MetaData';

// Landing page Stripe Checkout redirects back to after the customer pays
// an admin-sent top-up link. Verifies the payment directly with the
// backend (which re-checks with Stripe) rather than trusting the
// redirect itself.
const TopupReturn = () => {
    const [searchParams] = useSearchParams();
    const orderId = searchParams.get('order');
    const sessionId = searchParams.get('session_id');

    const [status, setStatus] = useState('checking'); // checking | paid | pending | error

    useEffect(() => {
        const verify = async () => {
            if (!orderId || !sessionId) {
                setStatus('error');
                return;
            }
            try {
                const { data } = await axios.get(`/api/v1/order/${orderId}/verify-topup?sessionId=${sessionId}`);
                setStatus(data.paid ? 'paid' : 'pending');
            } catch (error) {
                setStatus('error');
            }
        };
        verify();
    }, [orderId, sessionId]);

    if (status === 'checking') return <Loader />;

    return (
        <>
            <MetaData title="Payment Status | 1313 Mart" />
            <main className="w-full max-w-lg mx-auto mt-24 mb-24 px-4 text-center">
                {status === 'paid' && (
                    <>
                        <h1 className="text-2xl font-semibold text-primary-green mb-3">Payment Received</h1>
                        <p className="text-gray-600 mb-6">Thank you — your additional payment has been received and your order is fully up to date.</p>
                    </>
                )}
                {status === 'pending' && (
                    <>
                        <h1 className="text-2xl font-semibold text-primary-orange mb-3">Payment Not Completed</h1>
                        <p className="text-gray-600 mb-6">It looks like the payment wasn't completed. You can try again from your order details page.</p>
                    </>
                )}
                {status === 'error' && (
                    <>
                        <h1 className="text-2xl font-semibold text-red-500 mb-3">Something Went Wrong</h1>
                        <p className="text-gray-600 mb-6">We couldn't verify this payment. Please contact support if you were charged.</p>
                    </>
                )}
                {orderId && (
                    <Link to={`/order_details/${orderId}`} className="inline-block bg-primary-blue text-white font-medium px-6 py-3 rounded shadow hover:shadow-lg">
                        View Order Details
                    </Link>
                )}
            </main>
        </>
    );
};

export default TopupReturn;